import { apiClient } from "./apiClient";

export const feedbackService = {
    async submitFeedback(token, data) {
        return apiClient("/feedback", {
            token,
            method: "POST",
            body: data,
        });
    },
};
